import {environment} from "../configApi";

export const getAllConstantsAPI = () => {
    return fetch(`${environment}/api/constants`, {
        method: "get",
        headers: {
            'Accept': 'application/json',
        },
    })
        .then(res => {
            if (res.status >= 400) {
                return res.json().then(data => {
                    return Promise.reject(new Error(data.message));
                });

            }
            return res.json();
        }).catch(error => {
            return Promise.reject(error)
        });
};
